import { TABLE_DATA_DEFAULT } from './config';
const pageTableConfig = {
    MaerskList: {
        fetchUrl: 'locked/list',
        fetchManner: 'get',
        // getFetchFormat: createFetchFormat('get'),
        TABLE_DATA_DEFAULT: [],
    },
    OrderList: {
        fetchUrl: '/book/check',
        fetchManner: 'post',
        TABLE_DATA_DEFAULT,
    },
    HplOrderList: {
        fetchUrl: '/hpl/book/check',
        fetchManner: 'post',
        TABLE_DATA_DEFAULT,
    },
    OrderListXN: {
        fetchUrl: '/book/check',
        fetchManner: 'post',
        TABLE_DATA_DEFAULT,
    },
    QueryAccountList: {
        fetchUrl: 'account/list?type=auth',
        fetchManner: 'get',
        TABLE_DATA_DEFAULT: [],
    },
    BookAccountList: {
        fetchUrl: 'account/list?type=book_auth',
        fetchManner: 'get',
        TABLE_DATA_DEFAULT: [],
    },
    GoAccountList: {
        fetchUrl: 'account/list?type=go_auth',
        fetchManner: 'get',
        TABLE_DATA_DEFAULT: [],
    },
};

function createFetchFormat(type) {
    if (type === 'get') {
        return function (ajaxData) {
            if (!ajaxData) return ajaxData;
            console.log(ajaxData, 'ajax');
        };
    }
}

export function getPageTableInfo(key) {
    return pageTableConfig[key] || {};
}
